// extracted by mini-css-extract-plugin
module.exports = {"kicker":"Kicker_kicker__d2LJb"};